import { useEffect, useState } from 'react';

import MessagingDialog from '@components/Layout/SinglePanel/MessagingDialog/MessagingDialog';
import MessagingIndicator from '@components/Layout/SinglePanel/MessagingIndicator';
import SinglePanelLayout from '@components/Layout/SinglePanel/SinglePanel/SinglePanel';

import useClinicConfig from '@hooks/useClinicConfig';

import { ChatView, createChatView, ParticipantType } from '@services/Chat';

import '@components/Layout/SinglePanel/SinglePanel/SinglePanel.scss';

function SinglePanelWithMessaging({
  children,
  title,
  footer,
  color,
  patron,
  maxWidth = 'sm',
  disablePadding = false,
  disableGutters = false,
  disableBuildNumber = true,
}: {
  children?: JSX.Element | JSX.Element[];
  title?: JSX.Element;
  footer?: JSX.Element;
  color?: String;
  patron: any;
  maxWidth?: false | 'sm' | 'xs' | 'md' | 'lg' | 'xl';
  disablePadding?: boolean;
  disableGutters?: boolean;
  disableBuildNumber?: boolean;
}) {
  const [chatPromise, setChatPromise] = useState<Promise<ChatView>>();
  const clinicConfig = useClinicConfig();

  useEffect(() => {
    const conversationId = patron?.properties?.conversationId;
    const patronId = patron?.id;
    if (conversationId && patronId) {
      const chat = createChatView(
        conversationId,
        ParticipantType.User,
        patronId
      );
      setChatPromise(chat);
    }
  }, [patron]);

  return (
    <>
      <MessagingDialog chat={chatPromise} patron={patron} />
      <SinglePanelLayout
        extraButton={
          <MessagingIndicator chat={chatPromise} patronId={patron.id} />
        }
        logo={clinicConfig.logoName}
        title={title}
        footer={footer}
        color={color}
        maxWidth={maxWidth}
        disablePadding={disablePadding}
        disableGutters={disableGutters}
        disableBuildNumber={disableBuildNumber}
      >
        {children}
      </SinglePanelLayout>
    </>
  );
}

export default SinglePanelWithMessaging;
